'use strict';

var Type = require('../type');

module.exports = new Type('tag:yaml.org,2002:seq', {
  kind: 'sequence',
  construct: function (data) { return data !== null ? data : []; }
});



//////////////////
// WEBPACK FOOTER
// ./~/gray-matter/~/js-yaml/lib/js-yaml/type/seq.js
// module id = 611
// module chunks = 0